import React from 'react';
import { useSiteContent } from '../context/SiteContentContext';
import { MapPin, Clock, Phone, Mail, Facebook, Instagram } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  const { content } = useSiteContent();
  const phoneNumbers = content.phone_numbers || [];

  return (
    <footer id="kontakt" className="bg-[#2D4A5E] py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="md:col-span-1">
            <Logo size="medium" className="mb-4" />
            <p className="text-white/70 text-sm mt-4 leading-relaxed">
              {content.footer_description}
            </p>
            <div className="flex items-center gap-4 mt-4">
              {content.facebook_url && (
                <a
                  href={content.facebook_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-[#4CAF50] transition-colors"
                  title="Facebook"
                >
                  <Facebook className="w-6 h-6" />
                </a>
              )}
              {content.instagram_url && (
                <a
                  href={content.instagram_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-[#4CAF50] transition-colors"
                  title="Instagram"
                >
                  <Instagram className="w-6 h-6" />
                </a>
              )}
            </div>
          </div>

          {/* Working Hours */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2 justify-center md:justify-start">
              <Clock className="w-5 h-5 text-[#4CAF50]" />
              DELOVNI ČAS
            </h3>
            <p className="text-white/80 font-medium">{content.working_hours_weekdays}</p>
            <p className="text-white/70">{content.working_hours_weekend}</p>
            <p className="text-white/60 text-sm mt-2">{content.working_hours_note}</p>
          </div>

          {/* Contact */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2 justify-center md:justify-start">
              <Phone className="w-5 h-5 text-[#4CAF50]" />
              KONTAKT
            </h3>
            {phoneNumbers.map((phone, index) => (
              phone.number && (
                <div key={index} className="mb-2">
                  {phone.name && <span className="text-white/60 text-sm block">{phone.name}:</span>}
                  <a
                    href={`tel:${phone.number.replace(/\s/g, '')}`}
                    className="text-white/80 hover:text-[#4CAF50] transition-colors font-medium"
                  >
                    {phone.number}
                  </a>
                </div>
              )
            ))}
            {/* Fallback to old phone field if no phone_numbers */}
            {phoneNumbers.length === 0 && content.phone && (
              <a
                href={`tel:${content.phone.replace(/\s/g, '')}`}
                className="text-white/80 hover:text-[#4CAF50] transition-colors block font-medium mb-2"
              >
                {content.phone}
              </a>
            )}
            <a
              href={`mailto:${content.email}`}
              className="text-white/70 hover:text-[#4CAF50] transition-colors block text-sm mt-2"
            >
              {content.email}
            </a>
          </div>

          {/* Location */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2 justify-center md:justify-start">
              <MapPin className="w-5 h-5 text-[#4CAF50]" />
              LOKACIJA
            </h3>
            <p className="text-white/80">{content.address}</p>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} {content.company_name} {content.slogan}. Vse pravice pridržane.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
